var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTop = function SvgArrowTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.69 4.29 9.053.44a1.494 1.494 0 0 0-2.114 0L3.303 4.29a1 1 0 0 0 0 1.436.996.996 0 0 0 1.406 0L7 3.245V15a1 1 0 0 0 .997 1 .996.996 0 0 0 .998-1V3.24l2.289 2.5a.996.996 0 0 0 1.407 0 1 1 0 0 0 0-1.45"
  })));
};
export default SvgArrowTop;